var x = Object.defineProperty;
var I = (n, t, e) => t in n ? x(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var d = (n, t, e) => I(n, typeof t != "symbol" ? t + "" : t, e);
import { E as f } from "./index-es2.js";
import { a as g } from "./index-es.js";
let u = "/apiproxy";
const p = "/v1/notebook/note";
function E(n = null) {
  var t;
  u = ((t = n == null ? void 0 : n.trim()) == null ? void 0 : t.replace(/[/]+$/, "")) || "";
}
function m(n) {
  const t = `${u}${p}`, {
    id: e,
    color: r,
    text: h,
    metadata: a,
    token: l
  } = n, s = {
    asset_id: a.asset_id || null,
    color: r,
    highlight_id: e,
    note_text: h,
    token: l
  };
  Object.keys(a).forEach((i) => {
    i.slice(i.length - 3) === "_id" && a[i] && !(i in s) && (s[i] = a[i]);
  });
  const o = new FormData();
  return Object.keys(s).forEach((i) => {
    o.append(i, s[i]);
  }), g.post(t, o, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    withCredentials: !0
  });
}
function O(n) {
  const t = `${u}${p}/${n}`;
  return g.delete(
    t,
    { withCredentials: !0 }
  );
}
function w(n, t = !0) {
  const e = `${u}${p}`;
  return g.get(
    e,
    {
      params: {
        concept_id: n,
        exclude_orphans: t
      }
    }
  );
}
function C(n, t) {
  const e = `${u}${p}/${n}`;
  return g.patch(
    e,
    { note_text: t },
    { withCredentials: !0 }
  );
}
const c = class c {
  constructor() {
    d(this, "_clientId", null);
    d(this, "_highlight", null);
    d(this, "id", null);
    d(this, "metadata", null);
    d(this, "_text", null);
    d(this, "createdOn", null);
    d(this, "updatedOn", null);
    this._clientId = c.getNextClientId(), this._eventBus = new f(), this.metadata = {}, c.add(this);
  }
  get clientId() {
    return this._clientId;
  }
  get highlight() {
    return this._highlight;
  }
  set highlight(t) {
    this._highlight !== t && (this._highlight = t, this._highlight && (this._highlight.note = this));
  }
  get text() {
    return this._text || "";
  }
  set text(t) {
    this._text = t || null;
  }
  /**
   * Updates the data for the note from the given save-state data.
   * @param {Object} noteData The highlight save-state data.
   * @returns {Boolean} Returns `true` if successful, `false` otherwise.
   */
  createFromData(t) {
    return this.id = t.id || null, this.metadata = {
      asset_id: t.assetId,
      concept_id: t.guidConceptId,
      course_id: t.courseGuid,
      page_id: t.page_id,
      relationship_type_id: t.relationshipTypeGuid,
      subdiscipline_id: t.subdisciplineGuid,
      unit_id: t.unitGuid
    }, this.text = t.noteText, this.createdOn = new Date(t.createdOn), this.updatedOn = new Date(t.updatedOn), !0;
  }
  // TODO: implementation
  async create(t, e) {
    const { id: r, metadata: h, color: a } = t.highlight, { text: l } = t.note;
    return m({
      id: r,
      color: a,
      text: l,
      metadata: h,
      token: e
    }).then((o) => {
      this.id = o.data.id, this.createdOn = new Date(o.data.createdOn), this.updatedOn = new Date(o.data.updatedOn);
    });
  }
  async delete() {
    return O(this.id);
  }
  async update(t) {
    const { text: e } = t;
    return C(this.id, e).then((r) => (this.updatedOn = new Date(r.data.updatedOn), this.text = r.data.noteText, this));
  }
  /**
   * A map of the notes currently available on the page. The keys are based on `clientId`.
   * @static
   * @readonly
   * @type {Map}
   */
  static get notes() {
    return this._notes;
  }
  /**
   * Registers the Note instance with the singleton for managing it better.
   * This also helps ensure we only attach event-listeners when there are active
   * instances on the page.
   * @param {Note} note An instance of the Note.
   */
  static add(t) {
    this.notes.set(
      t.clientId,
      t
    );
  }
  /**
   * Get a `Note` instance from the given client-id.
   * @param {Number} noteClientId The client-id for the requested note.
   * @returns {?Note} Returns the matching `Note` instance or `null` if not found.
   */
  static getByClientId(t) {
    const e = parseInt(t, 10);
    return this.notes.get(e) || null;
  }
  /**
   * Get a `Note` instance from the database id.
   * @param {String} noteId The id for the requested note.
   * @returns {?Note} Returns the matching `Note` instance or `null` if not found.
   */
  static getById(t) {
    return Array.from(this.notes).find((h) => h.id === t) || null;
  }
  /**
   * Returns a unique numeric client-id for the current window and increments the nextClientId counter by 1.
   * @returns {Number} A unique numeric client-id for the current window.
   */
  static getNextClientId() {
    const t = this._nextClientId;
    return this._nextClientId += 1, t;
  }
  static async retrieveAllNotes(t, e) {
    const h = (await w(t)).data.notes, a = [], l = /* @__PURE__ */ new Map();
    return e.forEach((s) => l.set(s.id, s)), h.forEach((s) => {
      const o = l.get(s.highlightId);
      if (!o)
        return;
      const i = new c();
      i.createFromData(
        s
      ), i.highlight = o, a.push(i);
    }), a;
  }
};
d(c, "_notes", /* @__PURE__ */ new Map()), d(c, "_nextClientId", 1);
let _ = c;
export {
  _ as N,
  E as s,
  C as u
};
